
import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { Sponsor } from 'globals/store/sponsors.data';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { GreyWrapperComponent } from 'src/app/components/wrappers/grey-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'manage-call-to-action',
    template: `
 <h3 class="heading call-to-action-title">Call to action</h3>
  <div class="toggle-section">
    @if(entity){
      <grey-wrapper class="half-column">
        <div class="entry-title">Call to action text</div>
        <joi-input [italicPlaceholder]="true" [fixedWidth]="true" [disabled]="readOnly" [(model)]="entity[ctaProp]" [placeholder]="'Learn more, Register now, Etc.'" (joiChange)="ctaDetailsChanged.emit()"></joi-input>
      </grey-wrapper>
    }
  </div>
  <div class="toggle-section">
    @if(entity){
      <grey-wrapper class="half-column"[ngClass]="{ warn: warn }" >
        <div class="entry-title">Call to action URL</div>
        <joi-input [each]="!!warn" (eachChange)="checkUrl($event)" [italicPlaceholder]="true" [fixedWidth]="true" [disabled]="readOnly" [(model)]="entity[urlProp]" [placeholder]="'http...'" (joiChange)="ctaUrlChanged()"></joi-input>
      </grey-wrapper>
    }
    <div class="warning" *ngIf="!!warn">Not a valid URL (Must start with http or https)</div>
  </div>

`,
    styleUrls: ["manage-call-to-action.scss"],
    standalone: true,
    imports: [JoiInputComponent, GreyWrapperComponent, CommonModule],
})
export class ManageCallToActionComponent<T extends Sponsor | Exhibitor, P extends keyof T> implements OnInit {
  @Input() entity: T // Sponsor | Exhibitor
  @Input() readOnly: boolean = true
  @Input() ctaProp: P
  @Input() urlProp: P

  pattern: RegExp = /^https?/ // /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/=]*)/
  warn: boolean

  @Output() ctaDetailsChanged: EventEmitter<void> = new EventEmitter()

  ngOnInit() {
    const valid = this.urlPassed()
    this.warn = !valid
  }

  urlPassed(currentValue: string = null) {
    const url = typeof currentValue === 'string' ? currentValue : this.entity[this.urlProp] // need to check type in case empty string is passed in
    const passed = this.pattern.test(url+ '')
    // console.log({ url, currentValue, passed, found })
    return !url || passed
  }

  checkUrl(url: string) {
    if (!this.warn) return // don't warn when typing, only un-warn
    this.warn = !this.urlPassed(url)
  }

  ctaUrlChanged() {
    const valid = this.urlPassed()
    this.warn = !valid
    this.ctaDetailsChanged.emit() // save whether valid or not
  }

}


